import { useMemo } from "react";

import { useTimelineDataStore, useTimelineStore } from "../store/timeline-context";
import { createFocusIndex, resolveAnnotationFocus } from "../utils/focus";

/** Share canonical track/collection focus across labels and canvas bars. */
export function useTimelineFocus() {
  const items = useTimelineDataStore((state) => state.items);
  const selectedId = useTimelineStore((state) => state.selectedSegmentId);
  const highlightedIds = useTimelineStore((state) => state.highlightedSegmentIds);
  const index = useMemo(() => createFocusIndex(items), [items]);
  return useMemo(() => resolveAnnotationFocus(index, selectedId, highlightedIds), [index, selectedId, highlightedIds]);
}
